// extracted by mini-css-extract-plugin
export default {"protecting-block":"styles_protecting-block__Z62SE"};